export const YANDEX_FEDERATION_ID = import.meta.env.VITE_YANDEX_FEDERATION_ID || '';
export const YANDEX_ORG_ID = import.meta.env.VITE_YANDEX_ORG_ID || '';
